import React, { useState, useEffect } from "react";
import { sbaAxios } from '../utils/sbaAxios';
import { getServices, insertUpdateService, deleteService } from "../../config/apiConfig";
import { AgGridReact } from "ag-grid-react";
import { Modal } from "react-bootstrap";
import { SBADrawer } from "../UiComponents/SBADrawer";
import { ToastContainer, toast } from "react-toastify";
export const Services = () => {

  const [servicesData, setServicesData] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newServiceId, setNewServiceId] = useState("");
  const [newServiceName, setNewServiceName] = useState("");
    const [showDrawer, setshowDrawer] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [ServiceId,setServiceId] = useState();

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    setshowDrawer(true);
    setNewServiceId("");
    setNewServiceName("");
  };

  const handleAddServices = async () => {
    const data ={
      "userId": 0,
      "userName": "",
      "createdBy": 0,
      "serviceId": newServiceId == "" ? 0 : newServiceId,
      "serviceName": newServiceName,
      "modifiedBy": 0
    }; 
    if(newServiceName)
    {
      try {
          const response = await sbaAxios({
              url: `${insertUpdateService}`,
              method: 'post',
              data: data,
          });

        if(response===-8999)
      {
        toast.warning("Service Name Already Exists", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
      }
       else  if (response>0) {
            closeModal();
            toast.success("Services Saved Successfully", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        servicesListData();
        }
      } catch (error) {
        console.error("Error updating services:", error);
      }
    }
    else{
      toast.warning("Please enter Service Name", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      })
    }
 
  
  };

  const closeModal = () => {
    setshowDrawer(false);
      setIsModalOpen(false);
      setShowModal(false);
  };

  const EditButtonRenderer = (props) => {
    const roleData = props.data;
    const handleEditClick = () => {
      onEditButtonClick(roleData);
    };

    return (
      <div className="actions-cell">
        <i className="fas fa-edit" style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }} onClick={handleEditClick}></i>
      </div>)
  };
  const onEditButtonClick = (roleData) => {
    setIsModalOpen(!isModalOpen);
    setshowDrawer(true);
    setNewServiceId(roleData.ServiceId);
    setNewServiceName(roleData.ServiceName);
  };
    const DeleteButtonRenderer = (props) => {
    const roleId = props.data.ServiceId;
      const handleDeleteClick = () => {
          setShowModal(true);
          setServiceId(roleId)
    };
  
    return (
      <div className="actions-cell">
        <i className="fas fa-trash" style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }} onClick={handleDeleteClick}></i>
      </div>
    );
  };

    const onDeleteButtonClick = () => {
        setShowModal(false);
        sbaAxios({
            url: `${deleteService}${ServiceId}`,
            method: 'get',
        }).then(response => {
            if (response === -4444)  {
                closeModal();
                toast.error("Delete Failed, Role Mapped with this Service", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
            }
            else if (response === -3333) {
                closeModal();
                toast.error("Delete Failed, Tenant Mapped with this Service", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
            }
            else {
                closeModal();
                toast.success("Service Delete Successfully", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
                setTimeout(() => {
                    servicesListData();

                }, 100);

            }

        })
            .catch(error => {
                console.error('Error deleting data:', error);
            });
    }

  const servicesGridRowData = Array.isArray(servicesData)
    ? servicesData.map((row) => {
        const rowDataItem = {
          ServiceId: row.ServiceId,
          ServiceName: row.ServiceName,
        };
        return rowDataItem;
      })
    : [];

  const listofServicesColumnDefs = [
    { headerName: "ServiceName", field: "ServiceName" },
    {
      headerName: "Edit",
      field: "Edit",
      cellRenderer: EditButtonRenderer,
      maxWidth: 80,
    },
    {
      headerName: "Delete",
      field: "Delete",
      maxWidth: 100,
      cellRenderer: DeleteButtonRenderer,      
    },
  ];

  const defaultColDef = {
    sortable: false,
    filter: false,
    suppressMovable: true,
    flex: 1,
  };

  useEffect(() => {
    servicesListData();
  }, []);

  const servicesListData = async () => {
    try {
        const response = await sbaAxios({
            url: `${getServices}`,
            method: 'get',
        })
      const data = response;
      setServicesData(data);
    } catch (error) {
      console.error("Error fetching servicesListData from API:", error);
    }
  };

  return (
    <>
        <div className="row flex-wrap">
          <div className="header-container m-2 fs-12 col-lg-6">
            <b> Available Services </b>
            <button className="p-sm-btn mx-1" onClick={toggleModal}>
              <i className="fa-solid fa-plus" /> Add
            </button>
          </div>
          <div className="ag-theme-alpine m-1 col-lg-6" style={{ height: 550 }}>
            <AgGridReact
              columnDefs={listofServicesColumnDefs}
              rowData={servicesGridRowData}
              defaultColDef={defaultColDef}
            />
          </div>
        </div>
      <SBADrawer open={showDrawer} setOpen={setshowDrawer} close={false} title={'Add / Update Service'}>
      <div>           
      <div>
            <label className="header-container m-1"><b>Service Name</b></label>
            <div>
              <input
                className="form-control w-75"
                type="text"
                value={newServiceName}
                onChange={(e) => setNewServiceName(e.target.value)}
              />
            </div>           
          </div>
            <div className="mt-4">
            <button className="s-sm-btn mx-1" onClick={closeModal}>
            Cancel
          </button>
          <button className="p-sm-btn mx-1" onClick={handleAddServices}>
            Save
          </button>
            </div>
          </div>
          </SBADrawer>

          <Modal show={showModal}  >
              <Modal.Header closeButton onClick={closeModal}>
                  <Modal.Title>Do you want to delete the selected service?</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                  <p>The selected service will be deleted permanently. Are you sure?</p>
              </Modal.Body>
              <Modal.Footer>
                  <button className="s-sm-btn mx-1" onClick={closeModal} > Cancel</button>
                  <button className='p-sm-btn mx-1' onClick={onDeleteButtonClick} >
                      Yes
          </button>
              </Modal.Footer>
          </Modal>
    </>
  );
};
